
export const DevComponentsPage = () => {
  return (
    <h1>Dev Components Info</h1>
  )
}